import { Utils } from "@/plugins/utils";
import router from '@/router';
const ScanErro = require('../../../public/audio/ScanErro.wav')
import qs from 'qs'
import moment from "moment"

export default {
    namespaced: true,
    state: {
        lstMed: [],
        lstMea: [],
        lstBasket: [],
        med: {},
        mea: {},
        in1: {},
        insert: false,
        update: false,
        loading: false,
        itemsPerPage: 20,
        search: "",
        subClasses: [],
        since: moment().subtract(1, "day").startOf("day").toISOString(),
        until: moment().endOf("day").toISOString(),
        hasNext: false,
        lastUpdatedRegister: null,
        print: true,
        lastStep: 0
    },
    getters: {
        getUpdate(state) {
            return state.update
        },
        getMed(state) {
            let med = { ...state.med }
            med.meddata = med.meddata ? med.meddata : new Date(1900, 1, 1)
            med.medvalidad = med.medvalidad ? med.medvalidad : new Date()
            med.lstMea = state.lstMea
            return med
        },
        getSearch(state) {
            return state.search
        },
        getItemsPerPage(state) {
            return state.itemsPerPage
        },
        getSubclasses(state){
            return state.subClasses
        },
    },
    mutations: {
        set(state, med) {
			state.med = med || null
            if (med)
                state.update = true
		},
        setMea(state, mea) {
            state.mea = {...state.mea, meaidrecip: mea.meaidrecip, meainsumo: mea.meainsumo, meacodfab: mea.meacodfab}
        },
        setMed(state, med) {
            state.med = med
        },
        setMedordem(state, medordem) {
            state.med = {...state.med, medordem: medordem}
        },
        setIn1(state, in1) {
            state.in1 = in1
        },
        initForm(state) {
            state.insert = false
            state.update = false
            state.med = {}
        },
        setParamsDataTable(state, payload) {
            state.lstMed = payload.items
            state.itemsPerPage = payload.limit
            state.hasNext = payload.hasNext
        },
        setLoading(state, loading) {
            state.loading = loading
        },
        setLstMed(state, lstMed) {
            state.lstMed = lstMed
        },
        setLstMea(state, lstMea) {
            state.lstMea = lstMea
        },
        setLstBasket(state, lstBasket) {
            state.lstBasket = lstBasket.map(mea => {
                return { meaidrecip: mea.meaidrecip, meainsumo: mea.meainsumo, meacodfab: mea.meacodfab, isError: mea.isError, errorMessage: mea.errorMessage, lastStep: mea.lastStep }
            })

        },
        setHasNext(state, hasNext) {
            state.hasNext = hasNext
        },
        setSearch(state, search) {
            state.search = search
        },
        setLastUpdatedRegister(state, lastUpdatedRegister) {
            state.lastUpdatedRegister = lastUpdatedRegister
        }
    },
    actions: {
        initForm({ commit }) {
            commit("initForm")
        },
        async find({ commit, dispatch }, medcarga) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Oryxplace/CylinderFilling/Find/${medcarga}`)
                .then(response => {
                    let med = Utils.ValidateAxiosResponse(response.data);
                    commit("set", med)
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async get({ dispatch }, medcarga) {
            return await this._vm.$axios.get(`/Oryxplace/CylinderFilling/Find/${medcarga}`)
            .then(response => {
                return Utils.ValidateAxiosResponse(response.data);
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return null
            });
        },
        async save({ getters, dispatch }, { generateLoteAnv = false } = {}) {
            if (getters.getUpdate) {
                return await dispatch("update", { generateLoteAnv })
            }
            return await dispatch("insert", { generateLoteAnv })
        },
        async insert({ commit, getters, dispatch }, { generateLoteAnv = false } = {}) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true,  text: generateLoteAnv ? "Salvando lote" : "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.post("/OryxPlace/CylinderFilling/Insert", getters.getMed)
                .then(response => {
                    let med = Utils.ValidateAxiosResponse(response.data)
                    commit('setLastUpdatedRegister', med);
                    commit('set', med)
                    return med
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload;
        },
        async update({ commit, getters, dispatch }, { generateLoteAnv = false } = {}) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true,  text: generateLoteAnv ? "Salvando lote" : "Salvando", indeterminate: true }, { root: true })
            let payload = await this._vm.$axios.put(`/Oryxplace/CylinderFilling/Update?generateLoteAnv=${generateLoteAnv}`, getters.getMed)
                .then(response => {
                    let med = Utils.ValidateAxiosResponse(response.data)
                    commit('setLastUpdatedRegister', med);
                    commit('set', med)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
            return payload
        },
        async delete({ getters, dispatch }, medScreen = true) {
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Excluindo", indeterminate: true }, { root: true })
            await this._vm.$axios.delete(`/Oryxplace/CylinderFilling/Delete/${getters.getMed.medcarga}`)
                .then(response => {
                    Utils.ValidateAxiosResponse(response.data);
                    if (medScreen)
                        router.push("/oryxpdv/envases")
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
            dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
        },
        async findProductList({ commit, dispatch }, meacarga) {
            commit("setLoading", true)
            await this._vm.$axios.get(`/Oryxplace/CylinderFilling/FindProductList/${meacarga}`, )
                .then(response => {
                    let lstMea = Utils.ValidateAxiosResponse(response.data);
                    commit("setLstMea", lstMea)
                }).catch(error => {
                    commit("setLstMea", [])
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                })
            commit("setLoading", false)
        },
        async search({ commit, getters, dispatch, state }, { limit = 20, page = 1 }) {
            commit("setLoading", true)
            commit("initForm")

            let payload = await this._vm.$axios.get(
                `/Oryxplace/CylinderFilling/Search`,
                {
                    params: {
                        search: getters.getSearch,
                        limit,
                        page,
                        subclasses: getters.getSubclasses,
                        since: state.since,
                        until: state.until
                    },
                    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'repeat' })
                }
            )
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data)
                commit("setParamsDataTable", payload)
                return true
            })
            .catch((error) => {
                commit("setLstMed", [])
                commit("setSearch", "")
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true })
                return false
            })

            commit("setLoading", false)
            return payload
        },

        async findRecipByCode({ commit, dispatch }, idRecip) {
            var audioErro = new Audio(ScanErro)

            return await this._vm.$axios.get(`/Oryxplace/CylinderFilling/FindRecipByCode/${idRecip}`)
                .then(async response => {
                    let lstMed = Utils.ValidateAxiosResponse(response.data)

                    if (!lstMed || lstMed.length === 0) {
                        throw new Error()                    
                    }   

                    if (lstMed.length > 1) { 
                        await dispatch("me9/findByList", lstMed.map(med => med.meaidrecip), { root: true } )
                    } else if (lstMed.length > 0) {
                        commit("setMea", lstMed[0])
                    } 
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: "Cilindro não encontrado"
                    }, { root: true })
                    audioErro.play()
                    return false
                });
        },

        async existsMedLotAnv({ dispatch, getters }) {
            try {
                const response = await this._vm.$axios.post(`/Oryxplace/CylinderFilling/ExistsMedLotAnv/`, getters.getMed);

                return Boolean(response.data);
            } catch (error) {
                dispatch("parameters/openDialog", {
                    titleText: "Erro",
                    titleColor: "red",
                    text: error.message
                }, { root: true });
                return false;
            }
        },

        async validateRecip({ state, commit, dispatch }, { idRecip = null, isItemImport = false, ofqclapres = null }) {
            var audioErro = new Audio(ScanErro);
            const params = {
                meaidrecip: idRecip != null ? idRecip : state.mea.meaidrecip || null,
                medinsumo: state.med.medinsumo || null,
                medsubclas: state.med.medsubclas || null,
                lastStep: state.lastStep,
                ofqclapres: ofqclapres || 1,
                isItemImport: isItemImport
            }
            let response = await this._vm.$axios.post(`/OryxPlace/CylinderFilling/validateRecip`, params)
            .then(response => {
                let payload = Utils.ValidateAxiosResponse(response.data);
                commit("setLstBasket", payload)
                return payload
            })
            .catch((error) => {
                dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
                audioErro.play()
                state.med.mearecip = ''
				return null
            });
            return response
        },
        async findExpirationDate({ state, commit, dispatch }, { meainsumo = null, meaidrecip = null }) {
            const payload = {
                medinsumo: state.med.medinsumo,
                meaidrecip: meaidrecip ? meaidrecip : state.mea.meaidrecip,
                meainsumo: meainsumo ? meainsumo : state.mea.meainsumo
            }
            return await this._vm.$axios.post(`/Oryxplace/CylinderFilling/FindExpirationDate`, payload)
                .then(response => {
                    let payload = Utils.ValidateAxiosResponse(response.data);
                    commit("setIn1", payload)
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
        },
        async validateContent({ dispatch }, { meaidrecip, meainsumo, ofqclapres = null }) {
            let url = `/Oryxplace/CylinderFilling/ValidateContent?meaidrecip=${meaidrecip}&meainsumo=${meainsumo}`
            if (ofqclapres)
                url += `&ofqclapres=${ofqclapres}`
            return await this._vm.$axios.get(url)
                .then(response => {
                    let me9 = Utils.ValidateAxiosResponse(response.data)
                    if (!me9) {
                        throw new Error()
                    }
                    return true
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
        },
        async findByOrder({ commit, dispatch }, medordem) {
            commit("setLoading", true)
            commit("initForm")
            await this._vm.$axios.get(`/Oryxplace/CylinderFilling/FindByOrder/${medordem}`)
                .then(response => {
                    let med = Utils.ValidateAxiosResponse(response.data);
                    if (med)
                        commit("set", med)
                    return med
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
            commit("setLoading", false)
        },
        async insertReasonEdit(store, reason){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Cancelando a etiqueta", indeterminate: true }, {root: true})
			await this._vm.$axios.put(`/Oryxplace/CylinderFilling/InsertReasonEdit/${store.state.med.medcarga}?reason=${reason}` )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
				text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
    async printBatchLabel(store, params) {
      try {
        store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, { root: true });
        let payload = await this._vm.$axios.post("/Oryxplace/CylinderFilling/PrintBatchLabel", params);
        const relatPath = Utils.ValidateAxiosResponse(payload.data)
        if (!!relatPath) {
			await store.dispatch("print/openRelatsPath", [relatPath], { root: true })
		}

        return true;
      } catch (error) {
        store.dispatch("parameters/openDialog", {
          titleText: "Erro",
          titleColor: "red",
          text: error.message
        }, { root: true });
        return false;
      } finally {
        store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true });
      }
    },
        async findLabelsToPrint({ dispatch }, params) {
            return await this._vm.$axios.post("/Oryxplace/CylinderFilling/FindLabelsToPrint", params)
                .then(response => {
                    return Utils.ValidateAxiosResponse(response.data);
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
        },
        async validatePrintedLabel({ dispatch }, params ) {
            return await this._vm.$axios.post(`/Oryxplace/CylinderFilling/ValidatePrintedLabel`, params)
                .then(response => {
                    const payload = Utils.ValidateAxiosResponse(response.data);
                    return payload
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                    return false
                });
        },
        async insertReasonReprint(store, params){

            let lstToPrint = params.lstToPrint
            let reason = params.reason

			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Cancelando a etiqueta", indeterminate: true }, {root: true})
            const queryString = lstToPrint.map(item => `lstToPrint=${encodeURIComponent(item)}`).join('&');
			await this._vm.$axios.put(`/Oryxplace/CylinderFilling/InsertReasonReprint?${queryString}&reason=${reason}` )
			.then(response => {
				Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
				text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
        async findContent({ dispatch, state }, { text, meaidrecip, meainsumo }) {

            if (text == meainsumo)
                text = ''

            let existingMeainsumo = ''
            if (state.lstMea.length > 1)
                existingMeainsumo = state.lstMea[0]?.meainsumo

			return await this._vm.$axios.get(`/Oryxplace/CylinderFilling/FindContent?&text=${text}&meaidrecip=${meaidrecip}&existingMeainsumo=${existingMeainsumo}`)
				.then((response) => {
					return Utils.ValidateAxiosResponse(response.data);
				})
				.catch((error) => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true }
					);
					return [];
				});
		},
        async getNextBatchNumber({ dispatch }, medDate) {
            return await this._vm.$axios.get(`/Oryxplace/CylinderFilling/GetNextBatchNumber?meddata=${medDate}`)
                .then(response => {
                    return response.data.objectModel
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
        },
        async findInputByCode({ commit, dispatch }, meainsumo) {
            return await this._vm.$axios.get(`/Oryxplace/CylinderFilling/FindInputByCode/${meainsumo}`)
                .then(response => {
                    return Utils.ValidateAxiosResponse(response.data);
                })
                .catch((error) => {
                    dispatch("parameters/openDialog", {
                        titleText: "Erro",
                        titleColor: "red",
                        text: error.message
                    }, { root: true })
                });
        },
    }
}